<template>
  <div class="bg">
    <div class="banner"></div>
    <div class="introduce">
      <div class="bg-block"></div>
      <h3 class="title">公司简介</h3>
      <p class="title-en">COMPANY PROFILE</p>
      <i class="nav"></i>
      <div class="firstBox">
        <img class="first-img" src="../../assets/img/home/01.jpg" alt align="left" />

        <p
          class="first-content"
        >2019年玩咖欢聚全资收购深音互动科技(深圳)有限公司，深音互动现为玩咖广告业务华南区域的的主要机构，秉承“让营销更有效” 的使命，致力于为众多行业的知名企业提供高效的整合营销服务。深音互动目前为字节跳动全国区域普通代理商、VIVO、OPPO深圳区域二级代理，未来，陆续会接入更多的厂商媒介资源，力争打造又一个专业领先的企业级营销服务机构。朝着“数字营销领域国际化的公司” 及“精准营销领域的绝对领航者” 大步迈进。</p>
      </div>
      <div class="secondBox">
        <img class="second-img" src="../../assets/img/home/02.jpg" alt align="right" />
        <p
          class="second-content"
        >玩咖欢聚文化传媒（北京）有限公司(简称：玩咖欢聚)，成立于2014年，总部位于北京，是万咖壹联（Wanka Online Inc.）的境内业务主体公司。玩咖欢聚基于人工智能及数据分析能力，已建立安卓移动生态系统，包括智能手机制造商、广告主及应用开发者，并先后支 撑、服务于“硬核联盟”、“快应用标准组织”，以技术标准统一化，运营服务专业化，行业合作平台化的商业模式为广大广告主、开发者和手机厂商提供定制平台解决方案。</p>
      </div>
      <div class="thirdContentBox">
        <img class="third-img" src="../../assets/img/home/second.png" alt align="left" />
        <p
          class="third-content"
        >玩咖欢聚有自主研发的人工智能技术平台DAPG，DAPG 是一种以算法为基础的平台，支持高效分发内容，广告、游戏及视频等，通过内容及智能手机应用分析，抓取智能手机用户偏好，准确提供个人化的场景。并长期服务于电商、网服、互联网金融、在线旅游等核心行业，为客户提供营销策略、媒体整合、效果优化、创意、技术工具等服务。为加强与厂商联系，同时更好、更近距离服务华南区域的广告客户。</p>
      </div>
    </div>
    <div class="contact-us">
      <div class="left">
        <img src="../../assets/img/home/contact.png" alt class="contact-img" />
        <div class="contact-content">联系我们</div>
      </div>
      <div class="middlel">
        <p>深 圳 地 址：深圳市宝安区新安街道海滨社区N23区海天路15-1号卓越宝中时代广场一期A栋1006</p>
        <p>玩咖欢聚：www.wankacn.com</p>
        <p>媒 体 垂 询： pr@gm825.com</p>
      </div>
      <div class="right">
        <p>北 京 地 址： 北京市朝阳区酒仙桥路10号恒通商务园B22座4层</p>
        <p>万咖壹联: www.wankaonline.com</p>
        <p>商 务 合 作 邮 箱： mkt@gm825.com</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {}
};
</script>
<style scoped lang="scss">
.bg {
  width: 100%;
  height: 100%;
  font-family: Noto Sans S Chinese;
  .banner {
    position: relative;
    width: 100%;
    height: 560px;
    background: url("../../assets/img/home/001.png") no-repeat;
    background-size: cover;
    background-position: center;
    .bannerBox {
      position: absolute;
      height: 130px;
      width: 662px;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      .title {
        width: 685px;
        text-align: center;
        display: inline-block;
        font-size: 48px;
        font-weight: 900;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
        span {
          font-weight: 200;
        }
      }
      .content {
        width: 675px;
        margin-top: 38px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
        text-align: center;
      }
    }
  }

  .title {
    position: relative;
    padding-top: 90px;
    font-size: 36px;
    text-align: center;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .title-en {
    position: relative;

    // height: 11px;
    text-align: center;
    margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
  .nav {
    position: relative;

    width: 34px;
    height: 5px;
    display: block;
    margin: 14px auto 0px auto;
    background: rgba(0, 122, 255, 1);
  }
  .introduce {
    height: 1020px;
    background-color: #f7f6fd;
    .bg-block {
      position: absolute;
      background: url("../../assets/img/home/statistics.png") no-repeat;
      background-size: cover;
      width: 100%;
      height: 241px;
    }

    .firstBox {
      position: relative;

      background: url("../../assets/img/home/content-bg.png") no-repeat;
      margin: 15px auto 15px auto;
      // padding: 73px 75px 67px 93px;
      width: 1006px;
      height: 241px;
      line-height: 30px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      text-indent: 28px;

      .first-img {
        width: 256px;
        height: 170px;
        padding: 36px;
      }
      .first-content {
        width: 750px;
        padding-left: 220px;
        height: 200px;
        font-size: 14px;
        font-weight: 400;
        padding-top: 40px;
        color: rgba(102, 102, 102, 1);
      }
    }
    .secondBox {
      background: url("../../assets/img/home/content-bg2.png") no-repeat;
      margin: 15px auto 15px auto;
      // padding: 73px 75px 67px 93px;
      width: 1006px;
      height: 241px;
      line-height: 30px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      text-indent: 28px;

      .second-img {
        width: 256px;
        height: 170px;
        padding: 36px;
      }
      .second-content {
        margin-right: -50px;
        padding: 40px 0px 55px 35px;
        width: 750px;
        height: 200px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
    }
    .thirdContentBox {
      background: url("../../assets/img/home/content-bg.png") no-repeat;
      margin: 15px auto 15px auto;
      // padding: 73px 75px 67px 93px;
      width: 1006px;
      height: 241px;
      line-height: 30px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      text-indent: 28px;

      .third-img {
        width: 256px;
        height: 170px;
        padding: 36px;
      }
      .third-content {
        width: 750px;
        padding-left: 220px;
        height: 200px;
        font-size: 14px;
        font-weight: 400;
        padding-top: 40px;
        color: rgba(102, 102, 102, 1);
      }
    }
  }
  .contact-us {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 310px;
    background: rgba(33, 36, 51, 1);
    color: white;
    line-height: 32px;
    .left {
      padding-top: 90px;
      flex-grow: 6;
      height: 123px;
      text-align: right;
      .contact-img {
        margin-right: 7px;
      }
      .contact-content {
        height: 100%;
        font-size: 24px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
      }
    }
    .middlel {
      flex-grow: 2;
      padding-top: 60px;
      margin-left: 71px;
      height: 195px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(98, 102, 118, 1);
      line-height: 30px;
      p {
        padding-bottom: 28px;
      }
    }
    .right {
      flex-grow: 6;
      padding-top: 60px;
      height: 195px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(98, 102, 118, 1);
      line-height: 30px;
      p {
        padding-bottom: 28px;
      }
    }
  }
}
</style>
